import { Chevron } from "../icons/chevron";

const FilterDropdown = ({
  open,
  toggleOpen,
  children,
  title,
}: {
  open: boolean;
  toggleOpen: any;
  children: any;
  title: string;
}) => {
  return (
    <>
      <button
        onClick={toggleOpen}
        className="flex h-10 items-center justify-between rounded-xl px-2 dark:hover:bg-neutral-800 hover:bg-neutral-100"
      >
        <p className="font-medium">{title}</p>

        <Chevron
          size={30}
          className={`${
            open ? "rotate-180" : null
          } transition transform dark:text-neutral-300 `}
        />
      </button>
      {open ? (
        <div className="max-h-64 overflow-y-scroll">{children}</div>
      ) : null}
    </>
  );
};

export default FilterDropdown;
